__turbopack_context__.v({
  "article": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__article",
  "link": "EncyclopediaArticlesReference-module-scss-module__UCvRoq__link",
});
